const selectReduxPersist = (state) => state.appData.product // TODO refactor
export const selectIsAppRehydrated = (state) => selectReduxPersist(state).rehydrated
